<template>
    <!-- appNews 管理 -->
    <div class="app-news">
        <content-view v-show="$utils.renderWhen(this,'appNews')">
            <div slot="header">
                <a-form :form="form" layout="inline">
                    <a-form-item label="资讯标题">
                        <a-input placeholder="请输入" v-decorator="['title']"></a-input>
                    </a-form-item>
                    <a-form-item label="上传人">
                        <a-input placeholder="请输入" v-decorator="['staffName']"></a-input>
                    </a-form-item>
                    <a-form-item label="上传时间">
                        <a-date-picker v-decorator="['uploadDate']"/>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card
            :bordered="false"
            :tabList="tabListNoTitle"
            :activeTabKey="noTitleKey"
            @tabChange="key => onTabChange(key)"
            >
                <a-button slot="extra" v-if="getBtnByAuth('addNews')" class="mb16" type="primary" @click="toAddNews()">新增资讯</a-button>
                <a-table bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" :rowKey="record => record.id">    
                    <span slot="uploadDate" slot-scope="a, row">{{row.uploadDate && row.uploadDate.substr(0,10)}}</span>
                    <span slot="state" slot-scope="a, row">{{row.isEnable ? '使用中' : '已冻结'}}</span>
                    <span slot="action" slot-scope="a, row">
                        <span v-if="getBtnByAuth('updateNews')">
                            <a v-if="!row.isEnable" @click="toUpdateNews(row.id)" class="text-primary">编辑</a>
                            <span v-else class="text-disabled">编辑</span>
                            <a-divider type="vertical"/>
                        </span>
                        <a v-if="getBtnByAuth('detailNews')" @click="toDetailNews(row.id)" class="text-primary">详情<a-divider type="vertical"/></a>
                        <span v-if="getBtnByAuth('newsTop')">
                            <a v-if="row.isEnable" @click="topNews(row.id)" class="text-primary">顺序置顶</a>
                            <span v-else class="text-disabled">顺序置顶</span>
                            <a-divider type="vertical"/>
                        </span>
                        <span v-if="getBtnByAuth('updateNewsState')">
                            <a-popconfirm
                            :title="`确认将该资讯进行${row.isEnable ? '冻结' : '解冻'}操作？${row.isEnable ? '冻结' : '解冻'}后APP上将${row.isEnable ? '不再' : ''}展示该资讯`"
                            @confirm="stateNews(row.id, row.isEnable)"
                            >
                                <a class="text-primary">{{row.isEnable ? '冻结' : '解冻'}}</a>
                            </a-popconfirm>
                            <a-divider type="vertical"/>
                        </span>
                        <a-popconfirm
                        v-if="getBtnByAuth('newsDelete')"
                        title="确认将该资讯进行删除操作？删除后APP上将不再展示该资讯且后台无法再进行查看"
                        @confirm="deleteNews(row.id)"
                        >
                            <a class="text-primary">删除</a>
                        </a-popconfirm>
                    </span>
                </a-table>
            </a-card>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import moment  from 'moment';
    const tabListNoTitle = [
        {
            key: '1',
            tab: '使用中',
            columnLine: columns
        },
        {
            key: '0',
            tab: '已冻结',
            columnLine: columns
        },
    ]
    const columns = [
    {
        title: "编号",
        dataIndex: "id"
    },
    {
        title: "资讯标题",
        dataIndex: "title"
    },
    {
        title: "状态",
        dataIndex: "isEnable",
        scopedSlots: { customRender: "state" }
    },
    {
        title: "展示范围",
        dataIndex: "showCity"
    },
    {
        title: "上传时间",
        dataIndex: "uploadDate",
        scopedSlots: { customRender: "uploadDate" }
    },
    {
        title: "上传人",
        dataIndex: "staffName"
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }];
    export default {
        name: "appNews",
        components: {},
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                // 分页
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                tabListNoTitle,
                noTitleKey: '1'
            };
        },
        computed: {},
        methods: {
            handleReset() {
                this.form.resetFields();
                this.search();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            onTabChange(noTitleKey) {
                this.noTitleKey = noTitleKey;
                this.pagination.current = 1;
                this.getList();
            },

            // 获取APP资讯列表数据
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    values.uploadDate = values.uploadDate && values.uploadDate.format('YYYY-MM-DD');
                    values.isEnable = this.noTitleKey === '1' ? true : false;
                    this.$api.operation.newsList({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    }).then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    });
                });
            },
            // 跳转至新增
            toAddNews() {
                this.$router.push({
                    name: "addNews",
                });
            },

            // 跳转至编辑
            toUpdateNews(id) {
                this.$router.push({
                    name: "updateNews",
                    query: { id: id}
                });
            },

            // 跳转至详情
            toDetailNews(id) {
                this.$router.push({
                    name: "detailNews",
                    query: { id: id}
                });
            },

            // 置顶
            topNews(id) {
                this.$api.operation.newsTop({
                    params: {id: id}
                }).then(res => {
                    this.$message.success('操作成功', 2);
                    this.getList();
                })
            },

            // 冻结
            stateNews(id, isEnable) {
                this.$api.operation[isEnable ? 'newsFreeze' : 'newsUnfreeze']({
                    params: {
                        id
                    }
                }).then(res => {
                    this.$message.success('操作成功', 2);
                    this.getList();
                })
            },

            // 删除
            deleteNews(id) {
                this.$api.operation
                .deleteNews({
                    params: {id: id}
                })
                .then(res => {
                    this.$message.success('操作成功', 2)
                    this.getList()
                })
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        mounted() {
            this.getList();
        },
        watch: {
            $route(val) {
                val.name == "appNews" && this.getList();
            }
        }
    };
</script>
<style lang="scss">
    .app-news {
        .ant-calendar-picker {
            width: 100%;
        }
    }
</style>